(() => {
  const config = window.dropLockNavigation;
  if (!config?.enabled || config.designMode) return;

  const headerSelector = '.section-header';
  const rules = {
    home: true,
    collections: true,
    products: true,
    pages: true,
    blogs: true,
    search: true,
    cart: true,
    other: true,
    ...(config.routeRules || {}),
  };

  const toUrl = (value) => {
    if (!value) return null;
    try {
      return new URL(value, window.location.origin);
    } catch (error) {
      return null;
    }
  };

  const normalizePath = (value) => {
    const url = toUrl(value);
    if (!url || url.origin !== window.location.origin) return '';

    let pathname = url.pathname.replace(/\/{2,}/g, '/');
    if (pathname.length > 1) pathname = pathname.replace(/\/+$/, '');
    return pathname || '/';
  };

  const productUrl = toUrl(config.productUrl);
  const orderUrl = toUrl(config.orderUrl);
  const rootUrl = toUrl(config.rootUrl || '/');
  const rootPath = normalizePath(rootUrl?.pathname || '/') || '/';

  const stripRootPrefix = (pathname) => {
    if (!pathname || rootPath === '/') return pathname;

    const prefix = rootPath.endsWith('/') ? rootPath.slice(0, -1) : rootPath;
    if (pathname === prefix) return '/';
    if (pathname.startsWith(`${prefix}/`)) return pathname.slice(prefix.length) || '/';
    return pathname;
  };

  const canonicalPath = (value) => stripRootPrefix(normalizePath(value));

  const customExcludedPaths = String(config.customExcludedPaths || '')
    .split(/\r?\n/)
    .map((value) => value.trim())
    .filter(Boolean);

  const excludedPaths = new Set(
    (config.excludedPaths || [])
      .map(canonicalPath)
      .filter(Boolean),
  );
  const excludedPrefixes = [];

  customExcludedPaths.forEach((value) => {
    const isPrefix = value.endsWith('*');
    const normalizedValue = isPrefix ? value.slice(0, -1) : value;
    const pathname = canonicalPath(normalizedValue);
    if (!pathname) return;

    if (isPrefix) {
      excludedPrefixes.push(pathname);
    } else {
      excludedPaths.add(pathname);
    }
  });

  const productPath = productUrl?.origin === window.location.origin ? canonicalPath(productUrl) : '';
  const orderPath = orderUrl?.origin === window.location.origin ? canonicalPath(orderUrl) : '';

  const pathCategory = (pathname) => {
    if (pathname === '/') return 'home';
    if (pathname === '/collections' || pathname.startsWith('/collections/')) return 'collections';
    if (pathname === '/products' || pathname.startsWith('/products/')) return 'products';
    if (pathname === '/pages' || pathname.startsWith('/pages/')) return 'pages';
    if (pathname === '/blogs' || pathname.startsWith('/blogs/')) return 'blogs';
    if (pathname === '/search' || pathname.startsWith('/search/')) return 'search';
    if (pathname === '/cart' || pathname.startsWith('/cart/')) return 'cart';
    return 'other';
  };

  const isAllowedDestination = (url) => {
    if (!url) return true;
    if (url.origin !== window.location.origin) return true;

    const pathname = canonicalPath(url);
    if (!pathname) return true;
    if (pathname === productPath || pathname === orderPath) return true;
    if (pathname.includes('/challenge')) return true;
    if (config.allowPolicyPages && (pathname === '/policies' || pathname.startsWith('/policies/'))) return true;
    if (excludedPaths.has(pathname) || excludedPrefixes.some((prefix) => pathname.startsWith(prefix))) return true;

    return !rules[pathCategory(pathname)];
  };

  const isOrderAccessLink = (link) => {
    if (link.matches('[data-drop-order-access]') || link.closest('[data-drop-order-access]')) return true;
    if (!orderUrl) return false;

    const linkUrl = toUrl(link.href);
    return Boolean(linkUrl && linkUrl.toString() === orderUrl.toString());
  };

  const shouldRedirectLink = (link) => {
    if (!productUrl || isOrderAccessLink(link)) return false;
    return !isAllowedDestination(toUrl(link.href));
  };

  const prepareHeaderLinks = () => {
    if (!productUrl) return;

    document.querySelectorAll(`${headerSelector} a[href]`).forEach((link) => {
      if (!shouldRedirectLink(link)) return;
      if (!link.dataset.dropOriginalHref) link.dataset.dropOriginalHref = link.getAttribute('href') || '';
      link.dataset.dropRedirectLink = 'true';
      link.setAttribute('href', productUrl.toString());
      link.removeAttribute('target');
    });
  };

  document.addEventListener(
    'click',
    (event) => {
      const header = event.target.closest(headerSelector);
      if (!header || !productUrl) return;

      const orderLink = event.target.closest('a[data-drop-order-access]');
      if (orderLink) return;

      const link = event.target.closest('a[href]');
      if (link && (link.dataset.dropRedirectLink === 'true' || shouldRedirectLink(link))) {
        event.preventDefault();
        window.location.assign(productUrl.toString());
        return;
      }

      const searchButton = event.target.closest('.header__icon--search');
      if (searchButton && rules.search && !excludedPaths.has('/search')) {
        event.preventDefault();
        event.stopPropagation();
        window.location.assign(productUrl.toString());
      }
    },
    true,
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', prepareHeaderLinks, { once: true });
  } else {
    prepareHeaderLinks();
  }

  document.addEventListener('shopify:section:load', prepareHeaderLinks);
})();
